module.exports = __webpack_public_path__ + "img/icon-modalidad.7aab9153.svg";